import { useQuery } from "react-query";
import QUERY_KEYS from "../queryKeys";
import commonConfig from "../config";
import { getAthleteHighlightById, getAthletePostById } from "./queryFunctions";

export const useAthletePostById = (post_id, config = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.ATHLETE_POST_BY_ID, post_id],
    queryFn: () => getAthletePostById({ post_id }),
    ...commonConfig,
    ...config,
  });

export const useAthleteHighlightById = (h_id, config = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.ATHLETE_HIGHLIGHT_BY_ID, h_id],
    queryFn: () => getAthleteHighlightById({ h_id }),
    ...commonConfig,
    ...config,
  });
